import { Icon } from '@pwc/pwc-deals-ui';
import SupportTicketLink from '../SupportTicketLink';
import './PreviewErrorCard.scss';

interface Props {
  title?: string;
}
const PreviewErrorCard = ({
  title = 'Unable to load report page preview. Please refresh the browser to try again. If the issue continues please',
}: Props) => (
  <div className="preview-error-card-warning">
    <div className="preview-error-card-warning--body">
      <Icon className="fill icon-red" width="24" name="alert" />
      <div className="preview-error-card-warning--text-area">
        {title} <SupportTicketLink />
        {'. '}
      </div>
    </div>
  </div>
);

export default PreviewErrorCard;
